import { Tabs } from 'components/core-v2'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'

import { PATH } from '@/const'

import { TradeRiskDetailsTab } from '../../components/trade-risk-details-tab'
import { TradeRiskPortfolioTab } from '../../components/trade-risk-portfolio-tab'
import { TradeTemplate } from '../../templates/trade-template'

export const ReportingTradeRiskPage = () => {
  const { '*': tab, source, tradeId } = useParams()

  return (
    <TradeTemplate tabValue="trade-risk">
      <Tabs.List aria-label="Trade risk tabs" spacing="md">
        <Tabs.Tab
          isSelected={tab === 'details'}
          to={PATH.reportsSingleTradeTradeRiskDetails(source, tradeId)}
          value="details"
        >
          Details
        </Tabs.Tab>
        <Tabs.Tab
          isSelected={tab === 'portfolio'}
          to={PATH.reportsSingleTradeTradeRiskPortfolio(source, tradeId)}
          value="portfolio"
        >
          Portfolio
        </Tabs.Tab>
      </Tabs.List>
      <Routes>
        <Route
          element={<Navigate to={PATH.reportsSingleTradeTradeRiskDetails(source, tradeId)} />}
          path=""
        />
        <Route element={<TradeRiskDetailsTab />} path="details" />
        <Route element={<TradeRiskPortfolioTab />} path="portfolio" />
      </Routes>
    </TradeTemplate>
  )
}
